<div *transloco="let t" class="d-flex flex-column">
    <mat-form-field appearance="standard" class="w-100">
        <mat-label>{{ key }}</mat-label>
        <input matInput [formControl]="innerControl" />
        <mat-error>
            <td-validation-messages [control]="innerControl" [context]="{ name: key }"></td-validation-messages>
        </mat-error>
    </mat-form-field>
</div>
